import React, {Component} from 'react';
import {Toast} from '@react/react-spectrum/Toast';
import {MESSAGE_BOX_VARIANT, INSTALL_CCD_OS_TOAST} from '../../../../constants/AppPicker/appPickerConstants';
import MessageBoxScss from './MessageBox.scss';
import CCDUtil from '../../../../utils/CCDUtil';

export default class MessageBox extends Component {
	componentDidMount() {
		this.handleRenderEvent();
	}

	handleRenderEvent = () => {
		let value = '';
		const {variant, handleAnalyticsEvent} = this.props;
		switch (variant) {
			case MESSAGE_BOX_VARIANT.APP_OLD_VERSION :
				value = 'Older App version downloaded';
				break;
			case MESSAGE_BOX_VARIANT.CCD_NOT_SUPPORTED :
				value = 'Older Thor/CCD version downloaded';
				break;
			case MESSAGE_BOX_VARIANT.PHSP_32_BIT :
				value = 'Older 32 Bit App version downloaded';
		}
		if (variant === MESSAGE_BOX_VARIANT.INCOMPATIBLE_OS_TOAST) {
			handleAnalyticsEvent(INSTALL_CCD_OS_TOAST.RENDER.ID);
		}
		else if (variant !== MESSAGE_BOX_VARIANT.MUSE_EOL) {
			handleAnalyticsEvent({
				eventObj: {
					subcategory: `${CCDUtil.getCampaignWorkflowSubcategory()}:Toast`,
					type: 'render',
					subtype : 'os-toast',
					value
				}
			});
		}
	}

	onClose = (dialogType) => {
		const toastMessage = document.querySelector(`.${dialogType}`);
		if (toastMessage) {
			toastMessage.style.visibility = 'hidden';
		}
	}

	render() {
		const {variant, onClose, hasThor, className, id} = this.props;
		switch (variant) {
			case MESSAGE_BOX_VARIANT.CCD_NOT_SUPPORTED :
				return (
					<Toast
						id={id}
						closable
						actionLabel={this.props.intl.formatMessage({id: 'ccd.common.learnMore'})}
						onAction={this.props.onAction}
						onClose={() => this.onClose(variant)}
						className={`${MessageBoxScss.toast} ${variant} ${className}`}
					>
						{this.props.intl.formatMessage({id: 'apps.allAppsAppPicker.kaizen.ccdNotSupported'})}
					</Toast>
				);
			case MESSAGE_BOX_VARIANT.MUSE_EOL :
				return (
					<Toast
						id={id}
						closable
						actionLabel={this.props.intl.formatMessage({id: 'ccd.common.learnMore'})}
						onAction={this.props.onAction}
						onClose={() => this.onClose(variant)}
						className={`${MessageBoxScss.toast} ${variant} ${className}`}
						variant='info'
					>
						{this.props.intl.formatMessage({id: 'apps.allAppsAppPicker.kaizen.museEol'})}
					</Toast>
				);
			case MESSAGE_BOX_VARIANT.APP_OLD_VERSION :
				return (
					<Toast
						id={id}
						closable
						actionLabel={this.props.intl.formatMessage({id: 'ccd.common.learnMore'})}
						onAction={this.props.onAction}
						onClose={() => this.onClose(variant)}
						className={`${MessageBoxScss.toast} ${variant} ${className}`}
					>
						{this.props.intl.formatMessage({id: 'apps.allAppsAppPicker.kaizen.appOldVersion'}, {appname: this.props.appDisplayName})}
					</Toast>
				);
			case MESSAGE_BOX_VARIANT.PHSP_32_BIT :
				return (
					<Toast
						closable
						onClose={() => this.onClose(variant)}
						className={`${MessageBoxScss.toast} ${variant} ${className}`}
						onAction={this.props.onAction}
						actionLabel={this.props.intl.formatMessage({id: 'ccd.common.learnMore'})}
					>
						{this.props.intl.formatMessage({id: 'apps.allAppsAppPicker.kaizen.photoshop32bit'})}
					</Toast>
				);
			case MESSAGE_BOX_VARIANT.INCOMPATIBLE_OS_TOAST : {
				let ctaTextId;
				let messageTextId;
				if (hasThor) {
					ctaTextId = 'apps.appPicker.incompatibleOSView.toast.cta.thor';
					messageTextId = 'apps.appPicker.incompatibleOSView.toast.text.thor';
				}
				else {
					ctaTextId = 'apps.appPicker.incompatibleOSView.toast.cta.kaizen';
					messageTextId = 'apps.appPicker.incompatibleOSView.toast.text.kaizen';
				}
				return (
					<Toast
						id={id}
						closable
						onClose={() => {
							onClose();
							this.onClose(variant);
						}}
						onAction={this.props.onAction}
						actionLabel={this.props.showActionCTA && this.props.intl.formatMessage({id: ctaTextId})}
						className={`${MessageBoxScss.toast} ${variant} ${className}`}
						variant='info'
					>
						{this.props.intl.formatMessage({id: messageTextId})}
					</Toast>
				);
			}
		}
		return <div />;
	}
}